<template>
    <a href="javascript:void(0)" v-if="sender">
        <template v-if="viewType == 'list'">
            <div class="wrap single-chat-list">
                <div class="avatar-block">
                    <template v-if="sender.onlineStatus">
                        <span class="user-status online"></span>
                    </template>
                    <template v-else>
                        <span class="user-status busy"></span>
                    </template>
                    <img :src="profileImage" alt="" @click="$emit('handleSelection', sender,'profile')">
                </div>
                <div class="meta-block" @click="$emit('handleSelection', sender,'chat')">
                    <div class="meta">
                        <p class="name">
                            {{ sender.name }}
                        </p>
                        <template v-if="latestMessage">
                           <p class="recent-msg">{{ latestMessage }}</p>
                        </template>
                        <template v-else-if="'onlineStatus' in sender">
                            <p class="status-text">
                                {{ (sender.onlineStatus) ? 'Online' : 'Offline' }}
                                <template v-if="'newMessageSent' in sender && sender.newMessageSent">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2dd4bf" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                                    </svg>
                                </template>
                            </p>
                        </template>
                    </div>
                    <template v-if="unreadMessageCount > 0">
                        <div class="chat-count-block">
                            <div class="chat-time">
                                {{ $t('screener.chatroom.user.chat.just.now.text') }}
                            </div>
                            <div class="chat-count">
                                <p>{{ unreadMessageCount }}</p>
                            </div>
                        </div>
                    </template>
                    <div v-else-if="sender.is_rejected">
                        {{ $t('screener.chatroom.user.chat.rejected.text') }}
                    </div>
                    <div class="msg-icon" v-else>
                        <template v-if="'newMessageSent' in sender && sender.newMessageSent">
                            <svg width="50" height="50" viewbox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20" cy="20" fill="none" r="10" stroke="#F20C89" stroke-width="2">
                                    <animate attributeName="r" from="8" to="20" dur="1.5s" begin="0s" repeatCount="indefinite"/>
                                    <animate attributeName="opacity" from="1" to="0" dur="1.5s" begin="0s" repeatCount="indefinite"/>
                                </circle>
                                <circle cx="20" cy="20" fill="#F20C89" r="10"/>
                            </svg>
                        </template>
                        <template v-else>
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"></path>
                            </svg> -->
                            <div class="chat-indicator">
                                <div class="chat-bubble">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21 11.5C21 16.75 16.75 21 11.5 21C6.25 21 2 16.75 2 11.5C2 6.25 6.25 2 11.5 2C16.75 2 21 6.25 21 11.5Z" fill="currentColor"/>
                                    <path d="M22 22L20 20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                </svg>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="viewType == 'grid'">
            <div class="wrap single-chat-list" @click="$emit('handleSelection', sender,'chat')">
                <a href="javascript:void(0)">
                    <div class="avatar-block">
                        <template v-if="sender.onlineStatus">
                            <span class="user-status online"></span>
                        </template>
                        <img :src="profileImage" alt="" />
                    </div>
                </a>
            </div>
            <div class="user-profile">
                <div class="user-profile-popup">
                    <div class="user-meta">
                        <ul class="grid-user-profile-popup">
                          
                            <li class="user-info">
                                <p class="user-name">{{ sender.name }}</p>
                            </li>
                            <li class="drop-msg" @click="$emit('handleSelection', sender,'chat')">
                                <div class="msg-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" />
                                    </svg>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="user-bio">
                        {{ sender.bio }}
                    </div>
                </div>
            </div>
        </template>
    </a>
</template>

<script>

import ChatRoomService from "@/services/ChatRoomService";
import defaultProfileImage from '@/assets/placeholder.jpg';

export default {
    name: 'UserListItem',
    props: {
        viewType:{
            type:String,
            default:'list'
        },
        sender: {
            type: Object,
            default:null
        },
        receiver: {
            type: Object,
            default:null
        },
        chatID:{
            type:String,
            default:null
        },
        chatroomID:{
            type:String,
            default:null
        }
    },
    data(){
        return {
            unReadMessagesCount:null,
            notificationSound: new Audio(require('@/assets/new-notification-7-210334.mp3')),
            privateChat:null
        }
    },
    async mounted(){
        await this.listenToPrivateChat()
    },
    computed:{
        profileImage() {
            return this.sender.profile_image || defaultProfileImage;
        },
        unreadMessageCount(){
            let unreadMessagesCount = 0;
            if (this.privateChat) {
                // Calculate Unread Message Count
                unreadMessagesCount = Object.values(this.privateChat)
                .filter(message => 
                    message.senderId === this.sender.id && message.receiverId === this.receiver.id && message.isRead === false
                ).length;
                
            }
            return unreadMessagesCount
        },
        latestMessage(){
            let message = null;
            if (this.privateChat) {
                const sortedData = [...Object.values(this.privateChat)].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                message = sortedData[0].text
            }
            return message
        }
    },
    methods:{
        async listenToPrivateChat() {
            if (this.chatID) {
                let self = this
                await ChatRoomService.listenToPrivateChatMessages(this.chatroomID,this.chatID, (snapshot) => {
                    this.privateChat = snapshot
                });

            }
        }
        // playNotificationSound(){
        //     this.notificationSound.play().catch(error => {
        //         console.log('Failed to play notification sound:', error);
        //     });
        // }
    }
}
</script>

<style lang="scss" scoped>

</style>